import {
    SET_MAPMAKER_RIDING_PARTY_F,
    RESET_MAPMAKER_MAP_F
} from '../actions';

const initialState = {
    mapDiff: [],
    mapBoundsLng1: 41,
    mapBoundsLat1: -142,
    mapBoundsLng2: 65,
    mapBoundsLat2: -50
};

export default (state = initialState, action) => {
	switch (action.type) {
		case SET_MAPMAKER_RIDING_PARTY_F:
            console.log(action.mapDiff);
            console.log(action);
            return {...state, mapDiff: {...state.mapDiff, [action.ridingParty.riding]: action.ridingParty.switchTo }};
        case RESET_MAPMAKER_MAP_F:
            return {...state, mapDiff: {} };
        default: 
		    return { ...state };
	}
}